import { render } from "./index.vue?vue&type=template&id=6ade79c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6ade79c2&scoped=true&lang=css"

import exportComponent from "/root/funtrain-administration/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ade79c2"]])

export default __exports__